import { X } from 'lucide-react';
import ArrowLeftIcon from '../svg/ArrowLeftIcon';
import LogoImage from '../../assets/images/logo_blue.svg';

export default function LoginRightWrapper({ onGoToPage, backPath = '/login' }) {
  return (
    <div className="w-full flex items-center justify-between">
      <button
        onClick={() => onGoToPage(backPath)}
        className="cursor-pointer text-[32px] w-[32px] h-[32px] flex items-center text-gray-500 hover:text-gray-700 text-sm"
      >
        <ArrowLeftIcon className="w-5 h-5 text-gray-700 cursor-pointer" />
      </button>

      <div className="w-full flex items-center justify-center">
        <img src={LogoImage} alt="App Logo" className="w-25" />
      </div>

      <button
        onClick={() => onGoToPage('/')}
        className="text-[32px] w-[32px] h-[32px] flex items-center justify-center text-gray-500 hover:text-gray-700 text-sm"
      >
        <X className="w-5 h-5 text-gray-700 cursor-pointer" />
      </button>
    </div>
  );
}
